export const SELECTTEMPLATE = "SELECTTEMPLATE";
export const SELECTRESUME = "SELECTRESUME";
export const ADDPERSONALINFO = "ADDPERSONALINFO";
export const ADDEXPERIENCE = "ADDEXPERIENCE";
export const ADDALLEXPERIENCE = "ADDALLEXPERIENCE";
export const ADDNEWSKILLS = "ADDNEWSKILLS";
export const EDITSKILL = "EDITSKILL";
export const DELETESKILL = "DELETESKILL";
export const ADDEDUCATION = "ADDEDUCATION";
